import { render, staticRenderFns } from "./RightToolbarItem.vue?vue&type=template&id=61635a47&scoped=true"
import script from "./RightToolbarItem.vue?vue&type=script&lang=js"
export * from "./RightToolbarItem.vue?vue&type=script&lang=js"
import style0 from "./RightToolbarItem.vue?vue&type=style&index=0&id=61635a47&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61635a47",
  null
  
)

export default component.exports